import { useQuery } from "@tanstack/react-query";
import { listRenewals } from "./api";
import type { RenewalParams } from "./types";

export function useRenewals(params: RenewalParams) {
  return useQuery({
    queryKey: ["renewals", params],
    queryFn: () => listRenewals(params),
    placeholderData: (prev) => prev, // keep table mounted across page/filter changes
  });
}
